var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M550 437.558C531.812 442.183 520.562 437.761 510.469 422.605L438.687 323.292L428.312 309.542L344.484 422.933C334.906 436.573 324.859 442.511 306.984 437.683L414.328 293.589L314.391 163.433C331.578 160.089 343.453 161.792 354 177.183L428.453 277.73L503.453 177.73C513.062 164.089 523.391 158.902 540.641 163.933L501.891 215.308L449.391 283.667C443.141 291.48 444 296.824 449.75 304.37L550 437.558ZM50.125 291.183L58.9062 247.995C82.8125 162.527 180.781 127.011 248.344 179.824C287.828 210.886 297.641 254.824 295.687 304.042H73.125C69.7813 392.636 133.547 446.105 214.844 418.823C243.359 409.245 260.156 386.917 268.562 358.98C272.828 344.98 279.891 342.792 293.047 346.792C286.328 381.73 271.172 410.917 239.141 429.183C191.281 456.527 122.969 447.683 87.0312 409.683C65.625 387.636 56.7813 359.698 52.8125 329.823C52.1875 324.886 50.9375 320.183 50 315.448C50.0833 307.365 50.125 299.282 50.125 291.199V291.183ZM73.5313 285.245H274.656C273.344 221.183 233.453 175.683 178.937 175.292C119.094 174.824 76.125 219.245 73.5313 285.245Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/12.a2604e714d03002659af80e5b34acbf9.svg";
export { ForwardRef as ReactComponent };